export default __webpack_public_path__ + "static/media/Seccion_promos_pasada.8e38486a.webp";